<script>

  const grey = "#F2F0EE";


  const content = {
				meinung: {
          heading: "<b>Sie haben noch weitere Fragen?</b><br> Kontaktieren Sie uns!",
				},
				kontakt: {
					phone: "<b>(030) 290 21-550</b>",
					phone_link: "tel:+493029021550",
					email: "<b>leserservice@tagesspiegel.de</b>",
					email_link: "mailto:leserservice@tagesspiegel.de",
        }
  };


</script>

<section style:background={grey}>

  <div class="content t-info">
    <div class="meinung">
      <div class="t-info-title-small">{@html content.meinung.heading}</div>
    </div>
    <div class="kontakt t-copy-sans">
      <div>
        <img class="icon" id="phone" src="{PATH}assets/images/icons/tel.svg" alt="" /><a
          href="{content.kontakt.phone_link}">{@html content.kontakt.phone}</a
        >
      </div>
      <div>
        <img class="icon" id="email" src="{PATH}assets/images/icons/email.svg" alt="" /><a
          href="{content.kontakt.email_link}">{@html content.kontakt.email}</a
        >
      </div>
    </div>
  </div>

</section>

<style lang="scss">

$ff-sans: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
$ff-serif: "Abril Text", "Times New Roman", Times, serif;



  $breakpoint-mobile-tiny: 359px;
  $breakpoint-mobile: 544px;
  $breakpoint-tablet: 1280px;

  section {
    padding: 20px 0;
    color: #2a2a2a;
    font-family: $ff-serif;

    a {
      color: #2a2a2a;
    }
  }

	.t-info {
		text-align: center;
	}

	.t-info-title {
		font-size: 46px;
		line-height: 1.25;
		font-weight: normal;

		@media (max-width: $breakpoint-tablet) {
			font-size: 36px;
		}

		@media (max-width: $breakpoint-mobile) {
			font-size: 30px;
		}
	}

	.t-info-title-small {
		font-size: 32px;
		line-height: 1.25;
		font-weight: normal;

		@media (max-width: $breakpoint-tablet) {
			font-size: 30px;
		}

		@media (max-width: $breakpoint-mobile) {
			font-size: 28px;
		}
	}

	.t-copy-sans {
		font-family: $ff-sans;
		font-size: 20px;
		line-height: 1.45;
		letter-spacing: 0.01em;
		margin-top: 20px;
	}

	.content {
		max-width: 534px;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
    justify-content: center;
    padding: 70px 0;
	}

  .information {
		margin-bottom: 40px;
  }

  .meinung {
    margin-bottom: 30px;

    @media (max-width: $breakpoint-mobile) {
      margin-bottom: 25px;
    }
  }

	.kontakt {
    margin-top: 0px !important;

		> div {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-content: center;
      margin-bottom: 10px;

      @media (max-width: $breakpoint-mobile) {
        // justify-content: flex-start;
      }
		}

		a {
      text-shadow: none;
      text-decoration: none;

      &:hover {
        color: #000;
        text-decoration: underline;
      }
      
      @media (max-width: $breakpoint-mobile) {
        text-decoration: underline;
      }
		}
	}

	.icon {
		margin-right: 10px;

		&#phone {
			width: 25px;
      height: 25px;
      position: relative;
      top: 3px;
		}

		&#email {
			width: 29px;
			height: 29px;
		}
  }

  .sep {
    margin: 30px auto;
    width: 100%;
    height: 1px;
    background: #c9c9c9;

    @media (max-width: $breakpoint-mobile) {
      display: none;
    }
  }

  :global(.tslr-date) {
    text-align: center;
    display: none !important;
  }
</style>
